import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../styles/GlobalStyles';
import { serviceSectors } from '../data/serviceSectors';

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, rgba(40,82,111,0.95), rgba(64,120,170,0.9));
  color: #fff;
  padding: 3rem 0 1.5rem 0;
  width: 100%;
  font-family: 'Inter', sans-serif;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1.2fr;
  gap: 2rem;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  
  @media (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const FooterLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.2rem;
  min-width: 220px; /* Standard footer column width */
  position: relative;
  overflow: visible;
`;

const FooterLogoMark = styled.div`
  height: 336px; /* Same size as navbar logo: 7x bigger */
  width: 1260px; /* Same size as navbar logo: 7x bigger */
  -webkit-mask: url('/img_to_use/De-arc.svg') no-repeat left center;
  mask: url('/img_to_use/De-arc.svg') no-repeat left center;
  -webkit-mask-size: contain;
  mask-size: contain;
  background-color: #FFFFFF; /* Clean white color */
  filter: drop-shadow(0 2px 8px rgba(0,0,0,0.25));
  user-select: none;
  -webkit-user-drag: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1; /* Behind text content */
`;

// Remove image logo; keep text-only as requested

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  position: relative;
  z-index: 5; /* Ensure entire link container is above other elements */
`;

const FooterTitle = styled.h4`
  font-family: 'Playfair Display', serif;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.7rem;
  color: ${theme.colors.accent};
`;

const FooterLink = styled(Link)`
  position: relative;
  color: #cfd8df;
  text-decoration: none;
  transition: color 0.3s ease;
  padding-left: 1.2rem;
  cursor: pointer;
  z-index: 10; /* Ensure links are clickable */
  
  &:hover { 
    color: ${theme.colors.accent}; 
  }
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.68rem;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${theme.colors.accent};
    box-shadow: 0 0 0 2px rgba(255,215,0,0.2);
  }
`;

const Copyright = styled.div`
  text-align: center;
  color: #9fb0bd;
  font-size: 0.98rem;
  margin-top: 2.5rem;
`;

const Footer: React.FC = () => (
  <FooterContainer>
    <FooterContent>
      <FooterLogo>
        <FooterLogoMark />
        <span style={{ 
          color: '#fff', 
          fontSize: '1.05rem', 
          fontWeight: 400, 
          maxWidth: '280px',
          position: 'relative',
          zIndex: 10, /* Above the big logo */
          marginTop: '350px' /* Space for the big logo */
        }}>
          Your trusted partner in global staffing and recruitment solutions.
        </span>
      </FooterLogo>
      <FooterLinks>
        <FooterTitle>Quick Links</FooterTitle>
        <FooterLink to="/about">About Us</FooterLink>
        <FooterLink to="/services">Services</FooterLink>
        <FooterLink to="/process">Our Process</FooterLink>
        <FooterLink to="/contact">Contact</FooterLink>
        <FooterLink to="/privacy-policy">Privacy Policy</FooterLink>
        <FooterLink to="/terms-conditions">Terms & Conditions</FooterLink>
        <FooterLink to="/code-of-conduct">Code of Conduct</FooterLink>
      </FooterLinks>
      <FooterLinks>
        <FooterTitle>Sectors</FooterTitle>
        {serviceSectors.slice(0,6).map((s) => (
          <FooterLink key={s.slug} to={`/sectors/${s.slug}`}>{s.shortTitle || s.title}</FooterLink>
        ))}
      </FooterLinks>

      <FooterLinks>
        <FooterTitle>More Sectors</FooterTitle>
        {serviceSectors.slice(6).map((s) => (
          <FooterLink key={s.slug} to={`/sectors/${s.slug}`}>{s.shortTitle || s.title}</FooterLink>
        ))}
      </FooterLinks>
    </FooterContent>
    <Copyright>
      © {new Date().getFullYear()} De ARC Global. All rights reserved.
    </Copyright>
  </FooterContainer>
);

export default Footer;

